import { createAction } from 'redux-act';
import fetch from 'axios';
// eslint-disable-next-line import/no-unresolved
import { push } from 'connected-react-router';

/**
 * Create the action
 */

const request = createAction('TRAINING_EVALUATION_REQUEST');
const success = createAction('TRAINING_EVALUATION_SUCCESS');
const error = createAction('TRAINING_EVALUATION_ERROR');

function storeEvaluation(data) {
    return async function (dispatch) {
        // Dispatch the request action
        dispatch(request);

        try {
            const { response } = await fetch.post(`/api/evaluation`, data);
            /* dispatch(notify({
                message: 'Account aangemaakt!',
                dismissible: true,
                status: 'success',
                position: 'tc'
            })); */
            // Dispatch success action
            dispatch(success(response));
        } catch (err) {
            /*
            dispatch(notify({
                message: 'Zorg ervoor dat alle velden zijn ingevuld.',
                dismissible: true,
                status: 'error',
                position: 'tc'
            })); */
            dispatch(error(err));
            throw err;
        }
    };
}

/**
 * Export the components
 */

export { storeEvaluation as default };
export { request, success, error };
